import { tv } from "../../variants/tv.js";
const stageSlots = {
    stageContainerSlot: 'rounded-xl border-1 absolute inset-0 bottom-[33%]',
    headingSlot: 'p-3',
    imageSlot: '',
    imageClickableSlot: '',
    bodyOverlaySlot: '',
    innerContentSlot: 'relative'
};
const stagePaletteVariants = {
    neutral: '',
    primary: ''
};
const stageEmphasisVariants = {
    regular: {
        stageContainerSlot: 'bg-neutral-1 border-primary-2'
    },
    medium: '',
    bold: ''
};
const stageMediaVariants = {
    true: {
        stageContainerSlot: 'relative inset-auto bottom-auto block w-full overflow-hidden rounded-xl border-1 aspect-[4/3] @md:aspect-[21/9]',
        imageSlot: 'absolute inset-0 h-full w-full [&>*]:h-full [&>*]:w-full [&>*]:object-cover',
        headingSlot: 'flex flex-col justify-end p-0',
        innerContentSlot: 'relative -mt-19',
        bodyOverlaySlot: 'mx-3 pt-3'
    },
    false: {}
};
const stageImageActionableVariants = {
    true: {
        imageClickableSlot: 'group block w-full cursor-pointer rounded-xl text-left focus-visible:ring-2 focus-visible:ring-actionSecondary-12 focus-visible:ring-offset-2 focus-visible:outline-none'
    },
    false: {}
};
const isMediaAndImageActionableCompoundVariants = [
    {
        media: true,
        imageActionable: true,
        class: {
            stageContainerSlot: 'transition-shadow group-hover:shadow-xl',
            imageSlot: 'fill-mode-forwards'
        }
    }
];
const isEmphasisAndPaletteCompoundVariants = [
    {
        palette: 'neutral',
        emphasis: 'medium',
        class: {
            stageContainerSlot: 'bg-neutral-3 border-neutral-3'
        }
    },
    {
        palette: 'neutral',
        emphasis: 'bold',
        class: {
            stageContainerSlot: 'bg-neutral-12 border-neutral-12'
        }
    },
    {
        palette: 'primary',
        emphasis: 'medium',
        class: {
            stageContainerSlot: 'bg-primary-3 border-primary-3'
        }
    },
    {
        palette: 'primary',
        emphasis: 'bold',
        class: {
            stageContainerSlot: 'bg-primary-8 border-primary-8'
        }
    }
];
const stageDefaultVariants = {
    palette: 'primary',
    emphasis: 'regular',
    media: false,
    imageActionable: false
};
const stagePalettes = Object.keys(stagePaletteVariants);
const stageEmphasis = Object.keys(stageEmphasisVariants);
const stageVariants = tv({
    slots: stageSlots,
    variants: {
        palette: stagePaletteVariants,
        emphasis: stageEmphasisVariants,
        media: stageMediaVariants,
        imageActionable: stageImageActionableVariants
    },
    defaultVariants: stageDefaultVariants,
    compoundVariants: [
        ...isEmphasisAndPaletteCompoundVariants,
        ...isMediaAndImageActionableCompoundVariants
    ]
});
export { stageEmphasis, stagePalettes, stageVariants };
